<template>
  <div class="container">
    <div class="col-lg-4 col-md-6 ml-auto mr-auto">
      <form @submit.prevent="submitLogin">
        <card class="card-login card-white">
          <template slot="header">
            <img src="img/card-primary.png" alt="" />
            <h1 class="card-title">Change Password</h1>
          </template>
          <template v-if="changingPassword !== 'changed'">
              
            <div>
              <label>Nuova password</label>
              <base-input
                name="password"
                v-validate="'required|min:5'"
                :error="getError('password')"
                v-model="model.password"
                type="password"
                id="password"
                ref="password"
                placeholder="Password"
                addon-left-icon="tim-icons icon-lock-circle"
              >
              </base-input>
              <label>Ripeti</label>
              <base-input
                v-validate="'required|confirmed:password'"
                name="confirmPassword"
                type="password"
                :error="getError('confirmPassword')"
                v-model="model.confirmPassword"
                data-vv-as="password"
                placeholder="Password"
                addon-left-icon="tim-icons icon-lock-circle"
              >
              </base-input>

            </div>

            <div slot="footer">
              <base-button native-type="submit" type="primary" class="mb-3" size="lg" block>
                Cambia password

              </base-button>
            </div>
          </template>
          <template v-else>
            
            <h3 class="text-primary font-weight-bold">La password è stata cambiata con successo</h3>

            <h6>
              <router-link class="link footer-link text-primary" to="/login">
                <u>Torna al login</u>
              </router-link>
            </h6>
          </template>
        </card>
      </form>
    </div>
  </div>
</template>

<script>

import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      model: {
        password: '',
        confirmPassword: '',
      },
    };
  },
  computed: {
    ...mapState('account', ['changingPassword'])
  },
  created () {
    // reset login status
    this.logout();
  },
  methods: {
    ...mapActions('account', ['changePassword', 'logout']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async submitLogin() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        this.changePassword({
          password: this.model.password,
          passwordResetToken: this.$route.params.token
        });
        // TIP use this.model to send it to api and perform login call

      }
    }
  }
};
</script>
<style>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}
</style>
